<template id="checkbox">
    <div :class="wrapperClass">
        <input
            type="checkbox"
            v-model="checked"
            :id="checkboxConfig.elementId"
            :classlist="checkboxConfig.classList"
            tabindex="-1"
            :disabled="$attrs.disabled"
            @change="updateValue()"
            @keyup.enter="toggleCheckbox" />
        <div
            :class="{
                'cbs-checkbox__checkbox': true,
                'is-hover': getHover,
                'is-checked': getChecked,
            }"
            :aria-label="stripHtml(checkboxConfig.inputLabel)"
            @mouseover="setHover(true)"
            @mouseout="setHover(false)"
            :tabindex="checkboxConfig.tabIndex"
            @click="toggleCheckbox"
            @keypress.enter.space.prevent="toggleCheckbox"></div>
        <div
            class="cbs-checkbox__label-wrap"
            @mouseover="setHover(true)"
            @mouseout="setHover(false)">
            <!--
            Can set string values
            true-value="yes"
            false-value="no"
            -->
            <slot>
                <label
                    :for="checkboxConfig.elementId"
                    v-html="checkboxConfig.inputLabel"
                    @click="toggleCheckbox"
                    @keypress.enter.space.prevent="toggleCheckbox"></label>
            </slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CheckboxElm',
        model: {
            prop: 'checked',
            event: 'change',
        },
        props: {
            checkboxConfig: {
                type: Object,
                default: {
                    wrapperClass: 'cbs-checkbox',
                    elementId: '',
                    checked: false,
                    classList: ['qt-annualbox'],
                    tabIndex: -1,
                    inputLabel: '',
                },
            },
            errorMessage: {
                type: String,
                required: false,
            },
        },
        data: function () {
            return {
                checked: this.checkboxConfig.checked || false,
                isHovered: false,
            };
        },
        created: function () {
            this.$emit('change', { value: this.checked, origin: 'onCreated' }); //TODO refactor later for clarity
        },
        methods: {
            updateValue() {
                this.$emit('change', { value: this.checked });
                this.$emit('trackCheckBox', { value: this.checked });
            },
            setHover: function (bool) {
                if (!this.$attrs.disabled) {
                    this.isHovered = bool;
                }
            },
            toggleCheckbox: function (e) {
                if (!this.$attrs.disabled) {
                    this.followLabelLinks(e);
                    e.preventDefault();
                    e.stopPropagation();
                    this.checked = !this.checked;
                    this.updateValue();
                }
            },
            followLabelLinks: function (e) {
                if (e.target.href && e.target.href !== window.location.href)
                    window.open(e.target.href, '_blank');
            },
            stripHtml(html) {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                return doc.body.textContent || '';
            },
        },
        computed: {
            wrapperClass() {
                let list = [];

                if (typeof this.checkboxConfig.wrapperClass === 'string') {
                    list.push(this.checkboxConfig.wrapperClass);
                }

                if (typeof this.checkboxConfig.styleClass === 'string') {
                    list.push(this.checkboxConfig.styleClass);
                }

                if (this.errorMessage) {
                    list.push('error');
                }

                return list;
            },
            getHover: function () {
                return this.isHovered === true;
            },
            getChecked: function () {
                return this.checked === true;
            },
        },
    };
</script>
